module.exports = __webpack_public_path__ + "img/logo_blue.b450e05.png";